import React from 'react';

import FormGroup from 'ui-library/bs/FormGroup';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

export enum ValidationStatusFilter {
  ALL = 'ALL',
  WITH_ERRORS = 'WITH_ERRORS',
  WITHOUT_ERRORS = 'WITHOUT_ERRORS',
}

const ValidationStatusDisplayNames = {
  [ValidationStatusFilter.ALL]: 'All',
  [ValidationStatusFilter.WITH_ERRORS]: 'With errors',
  [ValidationStatusFilter.WITHOUT_ERRORS]: 'No errors',
};

interface TagSchemaValidationStatusFilterProps {
  onChangeValidationStatusFilter: (validationStatus: ValidationStatusFilter) => void;
  selectedValidationStatus: ValidationStatusFilter;
}

export default function TagSchemaValidationStatusFilter(
  props: TagSchemaValidationStatusFilterProps
): JSX.Element {
  return (
    <FormGroup>
      <FieldLabel label="Validation status" />
      <SelectDropdown
        menu={
          <Menu
            height={Menu.HEIGHTS.MEDIUM}
            width={Menu.WIDTHS.MEDIUM}
            value={props.selectedValidationStatus}
            isMulti={false}
          >
            {Object.values(ValidationStatusFilter).map((status) => (
              <Option
                value={status}
                key={status}
                onSelect={() => {
                  props.onChangeValidationStatusFilter(status);
                }}
              >
                {ValidationStatusDisplayNames[status]}
              </Option>
            ))}
          </Menu>
        }
        displayName={ValidationStatusDisplayNames[props.selectedValidationStatus]}
      />
    </FormGroup>
  );
}
